module.exports = __webpack_public_path__ + "img/icon_arrow_down.2e8e38cd.png";